import React from 'react';
import markdownContent from '!!raw-loader!static/terms.md';
import { Markdown } from 'Common';

export const ExternalTermsPage = () => {
  return <Markdown>{markdownContent}</Markdown>;
};
